import { useSelector, shallowEqual } from "react-redux";
import {
  getItemCount,
  hasFacets as getHasFacets
} from "../../state/modules/search";
import { getError } from "../../state/modules/error";
import {
  getIsNewSearch,
  getIsLoading
} from "../../state/modules/search/selectors";
import { getFeatures } from "../../state/modules/featureToggles/selectors";
import ProductListingPage from "../../components/ProductListingPage";
import useExperimentalParamsActivation from "./useExperimentalParamsActivation";

const ConnectedProductListingPage = props => {
  useExperimentalParamsActivation();

  const itemCount = useSelector(getItemCount);
  const error = useSelector(getError);
  const isNewSearch = useSelector(getIsNewSearch);
  const hasFacets = useSelector(getHasFacets);
  const featureToggles = useSelector(getFeatures, shallowEqual);
  const isLoading = useSelector(getIsLoading);

  const stateProps = {
    itemCount,
    error,
    isNewSearch,
    hasFacets,
    featureToggles,
    isLoading
  };

  return <ProductListingPage {...{ ...props, ...stateProps }} />;
};

export default ConnectedProductListingPage;
